import { render, staticRenderFns } from "./Sales20192020.vue?vue&type=template&id=594792b2&"
import script from "./Sales20192020.vue?vue&type=script&lang=js&"
export * from "./Sales20192020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports